export default class FieldProto {

    public _version             : number = 1
    public aggregateType        : any
    public formulaCompatible    : boolean = false

    constructor() {
        this.aggregateType = null;

        this.formulaCompatible = false;
    }

    get sortHintMessage():string|false {
        console.error(this.constructor.name, 'sortHintMessage not implemented!');
        return false
    }

    isFormulaCompatible():boolean {
        return this.formulaCompatible
    }

    getCsvValue(item:any):any {
        console.error(this.constructor.name, 'getCsvValue not implemented!');
        return null
    }

    getValue(item:any):any {
        console.error(this.constructor.name, 'getValue not implemented!');
        return null
    }

    getValueType() {console.error(this.constructor.name, 'getValueType not implemented!'); return null}

    getFormulaValue(item:any) {
        let res;
        switch (this.getValueType()) {
            case gd.const.fields.valueType.FLOAT:       res = this.getValue(item); break;
            // case gd.const.fields.valueType.STRING:      res = '\'{0}\''.f(this.getCsvValue(item)); break;
        }
        return res;
    }

    getAggregateClass() {return null}
    getAggregateOptions() {return []}
    getDefaultAggregateFunction() {return null}

    listItemSortFunctions(sort : any /*asc/desc*/) {
        console.error(this.constructor.name, 'listItemSortFunctions not implemented!');
        return {
            functions: [() => 0],
            directions: [sort]
        }
    }


    get ListComponent():any {
        console.error(this.constructor.name, 'ListComponent not implemented!');
        return false
    }

    get ViewComponent() {
        console.error(this.constructor.name, 'ViewComponent not implemented!');
        return false
    }

    get EditComponent() {
        console.error(this.constructor.name, 'EditComponent not implemented!');
        return false
    }

    getRenderComponent() {
        console.error(this.constructor.name, 'getRenderComponent not implemented!');
        return false
    }

    get AggregateComponent() {
        console.error(this.constructor.name, 'AggregateComponent not implemented!');
        return false
    }

    get version():number {
        return this._version
    }

}
